import UploadOutlined from "@ant-design/icons/lib/icons/UploadOutlined";
import { useMutation, useQuery } from "@tanstack/react-query";

import { Alert, App, Button, Col, Form, Row, Spin, Typography, Upload, UploadFile } from "antd";
import React, { useState } from "react";

import GestaoDeArquivos from "../../../../../Documentos/GestaoDeArquivos";
import TypeViagem from "../../../../../Models/Domain/Viagem/Viagem";
import ViagemService from "../../../../../Services/Domain/Viagem/ViagemService";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";

export const Arquivos: React.FC<{ viagem: TypeViagem }> = (props) => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    const app = App.useApp();

    interface IUploadForm {
        arquivos: File[];
    }

    const arquivosAtuais = useQuery({
        queryKey: ["ViagemService.listarArquivosDiversos"],
        queryFn: () => {
            const codigo = props.viagem.codigo;
            if (codigo == undefined) return Promise.reject();
            return ViagemService.listarArquivosDiversos(codigo);
        },
        enabled: true,
    });

    const adicionarArquivos = useMutation({
        mutationKey: ["ViagemService.inserirArquivos"],
        mutationFn: (payload: { arquivos: File[]; codigoDaViagem: number }) => ViagemService.inserirArquivos(payload.codigoDaViagem, payload.arquivos),
        onSuccess() {
            app.notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Arquivos carregados"),
                duration: 1,
            });

            arquivosAtuais.refetch();
            setFileList([]);
        },
    });

    const onFinish = (form: IUploadForm) => {
        if (props.viagem.codigo === undefined) return;

        adicionarArquivos.mutate({ arquivos: form.arquivos, codigoDaViagem: props.viagem.codigo });
    };

    const uploadsRestantes = arquivosAtuais.data?.data == null ? 5 : 5 - Math.min(arquivosAtuais.data.data.length, 5);

    return (
        <div>
            <Row>
                <Col xs={24}>
                    <Spin spinning={arquivosAtuais.isFetching}>
                        <GestaoDeArquivos
                            arquivos={[...(arquivosAtuais.data?.data ?? [])]}
                            desativarFn={(codigoDoArquivo) =>
                                props.viagem.codigo == undefined ? Promise.reject() : ViagemService.removerArquivo(props.viagem.codigo, codigoDoArquivo)
                            }
                            depoisDeDesativar={() => {
                                app.notification.open({
                                    ...PropriedadesDeNotificacao.Sucesso("Arquivo removido"),
                                    duration: 1,
                                });
                                arquivosAtuais.refetch();
                            }}
                            listProps={{
                                header: (
                                    <React.Fragment>
                                        <Typography.Title level={5} style={{ margin: 0, textAlign: "center" }}>
                                            Arquivos adicionais da viagem
                                        </Typography.Title>
                                    </React.Fragment>
                                ),
                                footer:
                                    uploadsRestantes <= 0 ? (
                                        <Alert type="warning" description={"A viagem só pode ter até cinco arquivos adicionais"} />
                                    ) : (
                                        <React.Fragment>
                                            <Col xs={24}>
                                                <Form onFinish={onFinish} layout="vertical">
                                                    <Form.Item<IUploadForm>
                                                        name="arquivos"
                                                        getValueFromEvent={(e) => {
                                                            return e.fileList.map((file: UploadFile) => file.originFileObj).filter(Boolean);
                                                        }}
                                                    >
                                                        <Upload
                                                            maxCount={uploadsRestantes}
                                                            beforeUpload={() => false}
                                                            multiple
                                                            listType="picture"
                                                            fileList={fileList}
                                                            showUploadList={{ previewIcon: true }}
                                                            onChange={(info) => {
                                                                setFileList(info.fileList);
                                                            }}
                                                            onRemove={(file) => {
                                                                setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
                                                            }}
                                                        >
                                                            <Button icon={<UploadOutlined />}>Novo arquivo</Button>
                                                        </Upload>
                                                    </Form.Item>

                                                    <Button type="primary" htmlType="submit" disabled={adicionarArquivos.isPending || fileList.length < 1}>
                                                        Carregar
                                                    </Button>
                                                </Form>
                                            </Col>
                                        </React.Fragment>
                                    ),
                            }}
                            permitirCompartilhamento={() => true}
                        />
                    </Spin>
                </Col>
            </Row>
        </div>
    );
};

export default Arquivos;
